<template>
    <div class="custom-select">
        <div class="grid" :style="{ gridTemplateColumns: `repeat(${columns}, 1fr)` }">
            <ActionButton
                v-for="(option, index) in options"
                :key="index"
                @click="updateValue(option.value)"
                size="small"
                class="px-5 text-sm uppercase"
                :muted="modelValue != option.value"
            >
                <div class="flex items-center justify-center">
                    <p>
                        {{ option.label }}
                    </p>
                </div>
            </ActionButton>
        </div>
    </div>
</template>

<script>
import ActionButton from '@/components/ui/ActionButton.vue'

export default {
    name: 'CustomSelect',
    components: {
        ActionButton,
    },
    props: {
        modelValue: {
            default: '',
        },
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    computed: {
        columns() {
            return this.options.length
        },
    },
    methods: {
        updateValue(value) {
            this.$emit('update:modelValue', value)
        },
    },
}
</script>

<style lang="scss">
.dualselect {
    select {
        border-radius: 6px;
        border: 1px solid #ccc;
        font-size: 1rem;
    }
}
</style>
